import gql from 'graphql-tag';
import {ArtCollection, SimpleArtCollection} from './fragments';

export const AllClientsAndEmployeesQuery = gql`
  query allClientsAndEmployees {
    allClients {
      _id
      name
    }
    allEmployees {
      _id
      name
    }
  }
`;

export const AllClientsAndEmployeesQueryConfig = {
  options: () => ({fetchPolicy: 'network-only'})
};

export const ArtCollectionQuery = gql`
  query artCollectionsInformation($userId: String!) {
    user(_id: $userId) {
      _id
      name
      unpublishedOwnedArtCollections {
        ...ArtCollection
        filesSynced{
          filesOutOfSync
        }
      }
      publishedAllowedArtCollections {
        ...SimpleArtCollection
      }
      unpublishedAllowedArtCollections {
        ...SimpleArtCollection
      }
    }
    allClients {
      _id
      name
    }
  }
  ${ArtCollection}
  ${SimpleArtCollection}
`;

export const ArtCollectionQueryConfig = {
  options: ({match}) => {
    return {variables: {userId: match.params.userId}, fetchPolicy: 'network-only'};
  }
};

export const IsArtCollectionInSyncQuery = gql`
  query artCollectionsInformation($userId: String!) {
    user(_id: $userId) {
      _id
      name
      unpublishedOwnedArtCollections {
        ...ArtCollection
      }
      publishedAllowedArtCollections {
        ...SimpleArtCollection
      }
      unpublishedAllowedArtCollections {
        ...SimpleArtCollection
      }
    }
    allClients {
      _id
      name
    }
  }
  ${ArtCollection}
  ${SimpleArtCollection}
`;

export const IsArtCollectionInSyncQueryConfig = {
  options: ({match}) => {
    return {variables: {userId: match.params.userId}, fetchPolicy: 'network-only'};
  }
};



// WEBPACK FOOTER //
// ./src/qql-shared/queries.js